import React from 'react'
import { useDispatch, useSelector } from "react-redux";
import { Button, Dialog, DialogContent, Grid, CircularProgress, TextField, Typography, DialogActions, InputAdornment } from '@material-ui/core'
import { IAMAction } from '../../actions'
import GoogleIcon from "../../assets/images/Google.svg";
import { ReactSVG } from "react-svg";

import { SET_USER_DATA, USE_2FA } from '../../constants/IAMActionTypes';

const TwoFactor = ({ profile }) => {
    const dispatch = useDispatch()
    const use_2fa = useSelector((state) => state.iam.use_2fa)
    const [userToken, setUsertoken] = React.useState('')
    const [verifiedStatus, setVerifiedStatus] = React.useState({ status: 'NEW', verified: false, locked: false, reason: '' })

    const updateStatus = (data) => setVerifiedStatus({ ...verifiedStatus, ...data })

    const verify2FA = () => IAMAction.twoFactor.verify(profile.username, userToken, updateStatus)

    React.useEffect(() => {
        if (verifiedStatus.verified) {
            dispatch({ type: USE_2FA, value: false })
        } else {
            if (verifiedStatus.locked === 3) {
                dispatch({ type: SET_USER_DATA, value: { ...profile, islocked: 3, status: "USER_ACCOUNT_LOCKED" } })
            }
        }
    }, [verifiedStatus])

    return (
        <Dialog open={use_2fa} maxWidth="sm">
            <React.Fragment>
                <DialogContent>
                    <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                        <Grid item>
                            <Grid container direction='column' justify='flex-start' alignItems='center' spacing={2}>
                                <Grid item><Typography variant='h3' color='textSecondary'>Enter OTP from Google Authenticator App</Typography></Grid>
                                <Grid item><TextField autoFocus variant='outlined' InputProps={{ startAdornment: <InputAdornment style={{"paddingTop": "5px"}} position="start"><ReactSVG src={GoogleIcon} /></InputAdornment> }} error={verifiedStatus.status === 'ERROR'} label={verifiedStatus.status === 'ERROR' ? verifiedStatus.reason : null} size='small' type='number' value={userToken} onChange={(event) => setUsertoken(event.target.value)} onKeyPress={(e) => { e.key === 'Enter' ? userToken.length === 6 ? verify2FA() : null : null }} /></Grid>
                                {verifiedStatus.locked > 0 ? <Grid item><Typography variant='h5' color='error'>{3 - verifiedStatus.locked} tries left</Typography></Grid> : null}
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color='primary' disabled={userToken.length !== 6} onClick={verify2FA} startIcon={verifiedStatus === 'WORKING' ? <CircularProgress size={25} /> : null}>
                        <Typography variant='h5' color='textSecondary'>Verify OTP</Typography>
                    </Button>
                </DialogActions>
            </React.Fragment>
        </Dialog >
    )
}

export default TwoFactor
